import { Progress } from "@/components/ui/progress";
import { useLocalization } from "@/hooks/useLocalization";

interface PaymentProgressProps {
  totalAmount: number;
  paidAmount: number;
  remainingAmount: number;
}

export function PaymentProgress({ totalAmount, paidAmount, remainingAmount }: PaymentProgressProps) {
  const { t } = useLocalization();
  
  const progressPercentage = totalAmount > 0 ? Math.round((paidAmount / totalAmount) * 100) : 0;
  
  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm">
        <div>
          <span className="text-muted-foreground">{t('portal.progress.amountPaid')}</span>
          <span className="font-medium ml-2">€{paidAmount.toFixed(2)}</span>
        </div>
        <div>
          <span className="text-muted-foreground">{t('portal.progress.progress')}</span>
          <span className="font-medium ml-2">{progressPercentage}%</span>
        </div>
      </div>
      
      <Progress value={progressPercentage} className="h-2" />
      
      {remainingAmount > 0 && (
        <div className="text-sm">
          <span className="text-muted-foreground">{t('portal.progress.remaining')}</span>
          <span className="font-medium ml-2">€{remainingAmount.toFixed(2)}</span>
        </div>
      )}
    </div>
  );
}